import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Radar, CheckCircle2, Flame } from "lucide-react";

const timeAgo = (iso) => {
  const d = (Date.now() - new Date(iso).getTime()) / 1000;
  if (d < 3600) return "just now";
  if (d < 86400) return `${Math.floor(d / 3600)}h ago`;
  return `${Math.floor(d / 86400)}d ago`;
};

export const DemandRadarCard = () => {
  const [demands, setDemands] = useState(null);

  useEffect(() => {
    api.get("/match/demand-radar").then(({ data }) => setDemands(data.demands)).catch(() => setDemands([]));
  }, []);

  if (demands !== null && demands.length === 0) return null;

  return (
    <div className="mt-8 rounded-xl border border-[#27272A] bg-[#121212] p-6" data-testid="demand-radar-card">
      <div className="flex items-center gap-2">
        <Radar className="h-4 w-4 text-[#FF3B30]" />
        <h2 className="font-bold text-lg">Demand radar</h2>
        <span className="text-[10px] uppercase tracking-wider text-neutral-500 border border-[#27272A] rounded-full px-2 py-0.5">Live buyer wants</span>
      </div>
      <p className="mt-2 text-sm text-neutral-400">
        Real buyers are asking for these right now. Green = your catalogue already matches.
        <span className="text-[#FF3B30] font-semibold"> Red = nobody has it — upload it and the buyer is alerted instantly.</span>
      </p>
      <div className="mt-4 space-y-2">
        {demands === null && <div className="text-sm text-neutral-500">Scanning…</div>}
        {demands?.map((d, i) => (
          <div key={i} data-testid={`radar-row-${i}`} className="flex items-center gap-3 rounded-lg border border-[#27272A] bg-black/30 px-4 py-3">
            {d.you_match
              ? <CheckCircle2 className="h-4 w-4 text-[#34C759] flex-shrink-0" />
              : <Flame className="h-4 w-4 text-[#FF3B30] flex-shrink-0" />}
            <div className="min-w-0 flex-1">
              <div className="text-sm font-semibold truncate">"{d.text}"</div>
              <div className="text-xs text-neutral-500">
                {d.max_price != null ? `Budget up to $${d.max_price}` : "Any budget"} · {timeAgo(d.created_at)}
                {d.you_match && d.your_best_product && (
                  <span className="text-[#34C759]"> · matched by your "{d.your_best_product}"</span>
                )}
                {!d.you_match && d.matches_total === 0 && (
                  <span className="text-[#FF3B30] font-semibold"> · unfilled demand</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
